import captureError from '@disco/utils/captureError'
import { useCallback, useState } from 'react'
import { STORAGE_DISABLED_NOTIFICATION, STORAGE_FULL_NOTIFICATION } from '@disco/constants/notifications'
import { pushUINotification } from '@disco/utils/notifications'
import { isQuotaExceededError } from 'utils/local-storage'
export default function useLocalStorage<T>(
  key: string,
  initialValue: T,
): [T, (arg0: T | ((prevValue: T) => T)) => void] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      captureError(error)
      return initialValue
    }
  })
  const setValue = useCallback(
    (value: T | ((prevValue: T) => T)) => {
      try {
        const valueToStore =
          typeof value === 'function'
            ? (value as (prevValue: T) => T)(storedValue)
            : value
        setStoredValue(valueToStore)
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      } catch (error) {
        pushUINotification(isQuotaExceededError(error) ? STORAGE_FULL_NOTIFICATION : STORAGE_DISABLED_NOTIFICATION)
        captureError(error)
      }
    },
    [key, storedValue, setStoredValue],
  )
  return [storedValue, setValue]
}
